<div class="order-summary-cont sticky"  style="top: 140px;">

  @if (displayNavButton) {
    <div [ngClass]="{'showButton': displayNavButton}" class="nav-button-cont text-right w-full">
      <hire-form-navigation-button [display]="true"></hire-form-navigation-button>
    </div>
  }

  <div [ngClass]="{'showButton': displayNavButton}" class="order-summary shadow-md rounded-2xl">

    <!--SECTION: Institution -->
    @if (orderData.institution) {
      <div class="institute-logo-cont bg-white h-32 flex justify-center items-center rounded-t-2xl">
        <img src="assets/logos/{{ orderData.institution.institution_id }}.png" class="w-80 h-28 object-contain">
      </div>
    }

    <div class="bg-gwc-form-bg-gray font-medium text-xl py-3 flex-col justify-center items-center">
      <div class="text-center">{{ orderData.institution?.institution }}</div>
      <!-- <div class="text-center">{{ getDisplayGraduationTitle() }}</div> -->
      <div class="text-center">Casual Hire</div>
    </div>

    <!--SECTION: Qualifications-->
    @if (orderData.qualifications) {
      <div
        [ngClass]="{'rounded-b-xl': getCurrentStep()?.id === 'qualifications' }"
        class="bg-gwc-form-bg-gray border-t-4 border-gwc-page-bg-gray py-3 flex-col justify-center items-center">
        <div class="text-center fron-medium text-sm">Qualifications</div>
        <div class="text-center font-medium text-xl" >
          @if (orderData.qualifications.length === 0) {
            <div>
              None Selected
            </div>
          }
          @for (qualification of orderData.qualifications; track qualification.qualification_id || $index) {
            <div>
              {{ qualification.qualification.qualification }}
              @if (qualification.qualification_level_id) {
                ({{ qualification.qualification_level?.list_qualification_level?.qualification_level}})
              }
            </div>
          }
        </div>
      </div>
    }

    <!--SECTION: Collection date, pickup and dropoff-->
    @if (orderData.collection) {
      <div  class="bg-gwc-form-bg-gray border-t-4 border-gwc-page-bg-gray font-medium text-xl py-3 flex-col justify-center items-center">
        <div class="text-center pb-3">Regalia Collection</div>
        <div class="flex text-base px-3 pb-2">
          <div class="text-gwc-primary-red w-28">Pick up date</div>
          <div>{{  orderData.collection.pickup | f3date : 'longDateWithDay' }}</div>
        </div>
        <div class="flex text-base px-3">
          <div class="text-gwc-primary-red w-28">Drop-off by</div>
          <div>{{ orderData.collection.dropoff | f3date : 'longDateTimeWithDay' }}</div>
        </div>
        <!-- <div class="px-3 text-base flex flex-col mt-4">
        <div class="text-gray-700">Please note our hours of operation for these dates</div>
        <div *ngFor="let date of openingHours" class="flex flex-row ml-4">
          <div class="w-24">{{ date.date | f3date : 'dayOfWeekLong' }}</div>
          <div class="w-28">{{ date.date | f3date : 'mediumDate' }}</div>
          <div class="">
            <ng-container *ngIf="date.opening_time === 'CLOSED'">
              CLOSED
            </ng-container>
            <ng-container *ngIf="date.opening_time !== 'CLOSED'">
              {{ date.opening_time | f3date: '12HourTimeWithMeridiem' }} - {{ date.closing_time | f3date : '12HourTimeWithMeridiem' }}
            </ng-container>
          </div>
        </div>
      </div>  -->
    </div>
  }



  @if (orderData?.regalia?.length > 0) {
    <div class="bg-gwc-form-bg-gray border-t-4 border-gwc-page-bg-gray font-medium text-base py-3 px-4 flex-col justify-center items-center">
      <div class="text-center text-xl pb-3">Regalia Hire</div>
      @for (item of orderData.regalia; track item.institution_qualification_regalia_id || $index; let first = $first) {
        <div class="flex">
          @if (item && item.institution_qualification_regalia_id === 'late_fee') {
            <div class="flex-grow">Late Fee</div>
            <div class="w-1/4">
              @if (first) {
              }
            </div>
            <div class="w-1/4 text-right">{{ item.price | currency : orderCurrency : 'symbol' : '1.2-2' }}</div>
          }
          @if (item && item.institution_qualification_regalia_id === 'credit') {
            <div class="flex-grow">Credit</div>
            <div class="w-1/4">
              @if (first) {
              }
            </div>
            <div class="w-1/4 text-right">({{ item.price | currency : orderCurrency : 'symbol' : '1.2-2' }})</div>
          }
          @if (item && item.institution_qualification_regalia_id !== 'late_fee' && item.institution_qualification_regalia_id !== 'credit') {
            <div class="flex-grow">
              <div>{{ item.regalia.name }}</div>
            </div>
            <div class="w-1/4 text-right">
              <div class="font-medium">
                {{ item.price | currency : orderCurrency : 'symbol' : '1.2-2' }}
              </div>
            </div>
          }
        </div>
      }
    </div>
  }

  @if (orderTotal < 0) {
    <div class="border-solid border-4 border-gwc-form-bg-gray border-t-0 bg-orange-300 flex px-4 py-3 text-xl font-medium">
      <p class="font-normal text-sm">You are using a credit that meets or is more than the value of the order.
      Your card won't be charged but will be added as a payment method so we can capture a bond when you collect your regalia</p>
    </div>
  }

  @if (orderData?.regalia?.length > 0) {
    <div class="bg-white rounded-b-2xl flex px-4 py-3 text-xl font-medium">
      <div class="flex-grow">Total</div>
      <div class="flex flex-grow-0 items-center">
        <div class="text-gwc-text-body text-base leading-4">{{ orderCurrency }}</div>
        <div class="pl-1.5 leading-6">{{ orderTotal | currency : orderCurrency : 'symbol' : '1.2-2' }}</div>
      </div>
    </div>
  }



</div>

</div>

